"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _IconWrapper = _interopRequireDefault(require("./IconWrapper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var NightTwilightShift = function NightTwilightShift(_ref) {
  var viewBox = _ref.viewBox;
  return /*#__PURE__*/_react.default.createElement(_IconWrapper.default, {
    viewBox: viewBox
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.4823 10.3595L15.3926 10.1124L15.1382 10.0462L14.2334 9.81077L14.9705 9.23604L15.1777 9.07441L15.1621 8.81202L15.1065 7.87864L15.8811 8.40224L16.0988 8.54947L16.3436 8.45351L17.2143 8.11214L16.9557 9.01045L16.883 9.26311L17.0499 9.46623L17.6436 10.1886L16.7089 10.2204L16.4462 10.2294L16.3046 10.4509L15.8014 11.2385L15.4823 10.3595Z",
    fill: "#FFD600",
    stroke: "#C6A600"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.7767 14.3933L20.9354 14.603L21.198 14.5911L22.3985 14.5368L21.7114 15.5225L21.5611 15.738L21.6534 15.9841L22.0758 17.1096L20.9258 16.7605L20.6743 16.6841L20.4688 16.848L19.529 17.5976L19.5057 16.3958L19.5006 16.133L19.2812 15.9882L18.2782 15.3262L19.4137 14.9327L19.6621 14.8466L19.732 14.5932L20.0516 13.4348L20.7767 14.3933Z",
    fill: "#FFD600",
    stroke: "#C6A600"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.1873 11.4175L22.1258 11.2108L22.8285 11.8668L22.9223 10.9103L23.7629 10.4451L22.8821 10.0604L22.6997 9.1167L22.0618 9.83588L21.1074 9.71775L21.5944 10.5469L21.1873 11.4175Z",
    fill: "#C6A600"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.1302 19.3198L14.7822 18.2372L11.5636 16.3992C10.9668 15.2672 10.6278 13.9849 10.6278 12.625C10.6278 11.2111 10.9218 8.37817 11.5636 7.2138C8.56 8.1738 6 11.9601 6 15.5523C6 20.9207 10.1351 24.4997 15.1892 24.4997C18.4337 24.4997 22.4114 21.7509 23 20.026C22.1037 20.3387 20.139 20.9048 19.1319 20.9048C17.2619 20.9048 15.5341 20.3156 14.1302 19.3198Z",
    fill: "#FFD600",
    stroke: "#C6A600",
    strokeWidth: "2"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.64355 16C7.64355 16.5524 8.09116 17 8.64355 17C9.19595 17 9.64355 16.5524 9.64355 16C9.64355 15.4476 9.19595 15 8.64355 15C8.09116 15 7.64355 15.4476 7.64355 16Z",
    fill: "#C6A600"
  }));
};

NightTwilightShift.propTypes = {
  viewBox: _propTypes.PropTypes.string
};
NightTwilightShift.defaultProps = {
  viewBox: '0 0 30 30'
};
var _default = NightTwilightShift;
exports.default = _default;